import { assertUnreachable } from "@aderant/aderant-web-fw-core";
function getCellValue(row, columnId) {
    return row.values[columnId];
}
/**
 * Compares two cell values.
 */
export function compareCellValues(cellA, cellB) {
    //According to ECMA standards undefined should be sorted to the end of arrays, but this doesn't really make sense.
    //We want undefined first (unapplicable properties), then nulls, then the values sorted correctly.
    if (cellA === undefined) {
        if (cellB === undefined) {
            return 0;
        }
        return -1;
    }
    if (cellB === undefined) {
        return 1;
    }
    if (cellA === null) {
        if (cellB === null) {
            return 0;
        }
        return -1;
    }
    if (cellB === null) {
        return 1;
    }
    if (typeof cellA === "string" || typeof cellB === "string") {
        return cellA.toString().localeCompare(cellB.toString());
    }
    if (typeof cellA === "number" || typeof cellB === "number") {
        return cellA === cellB ? 0 : cellA > cellB ? 1 : -1;
    }
    if (cellA instanceof Date || cellB instanceof Date) {
        if (cellA instanceof Date && cellB instanceof Date) {
            const a = cellA.getTime();
            const b = cellB.getTime();
            return a === b ? 0 : a > b ? 1 : -1;
        }
        else {
            return cellA instanceof Date ? 1 : -1;
        }
    }
    if (typeof cellA === "boolean") {
        if (typeof cellB === "boolean") {
            return cellB ? (cellA ? 0 : -1) : cellA ? 1 : 0;
        }
        return 1;
    }
    if (typeof cellB === "boolean") {
        return -1;
    }
    assertUnreachable(cellA, cellB);
}
/**
 * Compares two rows based on the value at @param columnId.
 */
export function compareRows(rowA, rowB, columnId) {
    const cellA = getCellValue(rowA, columnId);
    const cellB = getCellValue(rowB, columnId);
    return compareCellValues(cellA, cellB);
}
